import React from "react";
import Container from 'react-bootstrap/Container';
import PageHeader from './PageHeader';
import PageBody from './PageBody';

const Page = ({ children, pageTitle, classs, id, style }) => {
  return (
    <section className={classs} id={id}>
        <PageHeader>{pageTitle}</PageHeader>
        <PageBody>{children}</PageBody>
      </section>
  );
};

export default Page;

